import React, {useEffect, useState, useRef} from "react";
import { Modal, Header, Icon, Button, Dimmer, Loader } from 'semantic-ui-react';
import FileUploadContent from "./FileUploadContent";
import useUploadFile from "../../hooks/useUploadFile";
import { useSelector } from "react-redux";
import FileUploadedMsgModal from "./fileUploadedMsgModal";
import MessageModal from "../commonComponents/MessageModal";

const FileUpload = () => {
    const [open, setOpen] = useState(false)
    const [file, setFile] = useState(null);
    const [secondOpen, setSecondOpen] = useState(false);
    const [displayMsg, setDisplayMsg] = useState({color: "black", message: "", title: ""});
    const {fileUpload, fileUploadLoading, startProcessingLoading, checkStatusLoading} = useUploadFile(setOpen, setDisplayMsg, setSecondOpen);
    const {reconLoader: {fileUploadLoader}} = useSelector((state) => state.loader)
    const uploadBtnIsDisabled = (fileUploadLoading || startProcessingLoading || checkStatusLoading || file?.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || !file) ? true : false
    
    useEffect(() => {
        if(displayMsg.message){
            setSecondOpen(true);
        }
        else{
            setSecondOpen(false);
        }
    }, [displayMsg])
    
    return ( <>
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => {setOpen(true); setFile(null)}}
            open={open}
            size='tiny'
            trigger={<Button compact className="recon-button">UPLOAD</Button>}
        >
            <Modal.Header>
                Upload File
            </Modal.Header>
            <Modal.Content className="reconFileUploadContent">
                <Dimmer.Dimmable active={fileUploadLoader}>
                    <Dimmer active={fileUploadLoader} inverted>
                        <Loader style={{padding: "20px"}}>File Processing...</Loader>
                    </Dimmer>
                    <FileUploadContent setDisplayMsg={setDisplayMsg} setFile={setFile} />
                </Dimmer.Dimmable>
            </Modal.Content>
            <Modal.Actions>
                <Button compact className="modal-recon-button" onClick={() => setOpen(false)}>Cancel</Button>
                <Button compact color='green' onClick={() => fileUpload(file)} disabled={uploadBtnIsDisabled}>
                    Upload
                </Button>
            </Modal.Actions>
            <MessageModal displayMsg={displayMsg} open={secondOpen} setOpen={setSecondOpen} setParentModal={setOpen} />
        </Modal>
    </> );
}
 
export default FileUpload;